// extracted by mini-css-extract-plugin
export var details = "_kj-0";
export var inspectorPopover = "_kj-1";